var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorfull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 961,
    height: 800,
    viewBox: "0 0 961 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_341",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H560C780.914 0 960 179.086 960 400V800H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M960.143 513H960V522C960 518.989 960.048 515.988 960.143 513Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-296 -9L-187.189 807L290 807L-28.0982 -9L-296 -9Z",
    fill: "url(#paint0_linear_7_341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.156 805L124 127.846L380.181 64.1728L665.743 -4L763.369 -4L707.502 117.267L940 804.865L389.156 805Z",
    fill: "url(#paint1_linear_7_341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.9115 -19L69.6748 246.804L-188 807L390.847 807L344.25 690.129L667 -4.88517L-38.9115 -19Z",
    fill: "#FFD100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.872 -48.4352L390 805L1244.88 805L1706 -232L784.872 -48.4352Z",
    fill: "#E20613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 -4.25821L666.796 -5L65 -5L344.5 691L667 -4.25821Z",
    fill: "url(#paint2_linear_7_341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-188 807L290 807L69.709 247L-188 807Z",
    fill: "url(#paint3_linear_7_341)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 805L888 805L678.102 181L390 805Z",
    fill: "url(#paint4_linear_7_341)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_341",
    x1: -55.7684,
    y1: 807,
    x2: -55.7684,
    y2: 147.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_341",
    x1: 531.796,
    y1: 805,
    x2: 531.796,
    y2: -6.25977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#118FB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_341",
    x1: 395.4,
    y1: 689,
    x2: 395.4,
    y2: -5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_341",
    x1: 51,
    y1: 247,
    x2: 51,
    y2: 807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAE6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_341",
    x1: 390,
    y1: 493.061,
    x2: 888,
    y2: 493.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfull);
export default __webpack_public_path__ + "static/media/colorfull.22bb6a4ec7e2ab74255849ec682d61cc.svg";
export { ForwardRef as ReactComponent };